module.exports = __webpack_public_path__ + "img/logo.36a4f67f.png";